import { render, staticRenderFns } from "./10c_doc.vue?vue&type=template&id=d7b98aec&scoped=true"
import script from "./10c_doc.vue?vue&type=script&lang=js"
export * from "./10c_doc.vue?vue&type=script&lang=js"
import style0 from "./10c_doc.vue?vue&type=style&index=0&id=d7b98aec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7b98aec",
  null
  
)

export default component.exports